/**
 * Identidade do profissional na sessão.
 *
 * O payload de `/data/self/get` expõe `id_interno` — NÃO existe
 * `id_profissional` ali (ver `aawz_base/routes/v2_new_web/general.py`). Um gate
 * apoiado só em `id_profissional` nunca passa, e o card não aparece para
 * ninguém. `utils/ownership.js` usa exatamente o mesmo fallback.
 *
 * Vive em arquivo próprio, e não no `index.js`, porque o gatilho também precisa
 * dele — importar do index criaria ciclo (index -> trigger -> index).
 */
export function idDoProfissional(usuario) {
  if (!usuario) return null
  return usuario.id_interno || usuario.id_profissional || null
}

/** Usuário interno da AAWZ nunca vê a pesquisa. */
export function ehInterno(usuario) {
  return !!(usuario && usuario.IS_INTERNAL)
}
